<template>
    <EChart
        card
        class="mt-3"
        :options="chartOptions"
        :header="$t('availability')"
        :error="requestChart.getError()"
        :loading="requestChart.getLoading()"
    >
        <template #nav>
            <MultiselectAvailableCampaigns v-model="campaigns" :disabled="requestChart.getLoading()" @change="loadData()" />
        </template>
    </EChart>
</template>



<script>
    import cloneDeep from 'lodash/cloneDeep';
    import MultiselectAvailableCampaigns from '@/components/common/MultiselectAvailableCampaigns.vue';
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'AvailabilityChart',
        components: {
            MultiselectAvailableCampaigns,
            EChart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChart: this.parentComponent.requestAvailabilityChart,
                requestCampaigns: this.$req('buyboxes/AvailableCampaigns'),
                campaigns: [],
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                return {
                    urlParams: {
                        id: this.item.id,
                    },
                    requestParams: {
                        startDate: this.timeRange?.startDate,
                        endDate: this.timeRange?.endDate,
                    },
                };
            },
            chartOptions() {
                const chartData = this.requestChart.getData();
                if (!chartData) {
                    return { series: [] };
                }
                const series = chartData
                    .filter(item => !!item.segments.length)
                    .sort((a, b) => a.label < b.label)
                    .map(item => ({
                        name: item.label,
                        type: 'rangeBar',
                        data: [{ name: item.label, data: item.segments.map(segment => ({ x: item.label, y: [segment.start, segment.end] })) }],
                    }));
                return {
                    legend: {
                        show: true,
                    },
                    xAxis: {
                        type: 'time',
                    },
                    series,
                };
            },
        },
        watch: {
            item: {
                immediate: true,
                handler: 'loadData',
            },
            timeRange: {
                immediate: false,
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.requestChart.reset();
                this.fetchChart();
            },
            fetchChart(params = { cache: false }) {
                const apiParams = cloneDeep(this.apiParams);
                if (this.campaigns?.length) apiParams.requestParams.campaigns = this.campaigns.map(item => item.id).join(',');
                this.requestChart.get({ ...apiParams, ...params });
            },
            fetchCampaigns() {
                const id = this.$store.getters['plugin/getProducerPlugin'].id;
                return this.requestCampaigns.get({ urlParams: { id, v: 1 } });
            },
        },
    };
</script>
